import { ApiResult } from 'api/fetchApi'

import { isClientError } from './isClientError'
import { isServerError } from './isServerError'

export const hasClientOrServerError = ({ ok, status }: ApiResult) => {
  return ok === false || isClientError(status) || isServerError(status)
}
